module.exports = __webpack_public_path__ + "assets/Levels.17c91eef5a5fb6f5c4e4178dcca6e68a.xml";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Levels.xml
// module id = 1031
// module chunks = 0